import { Button, FormControl, FormErrorMessage, FormLabel, Input, InputGroup, InputRightElement } from '@chakra-ui/react'
import React from 'react'

const FormInputPassword = ({ isRequired, error, onChange, onBlur, id, value, label, placeholder, ...rest }) => {
  const [show, setShow] = React.useState(false)
  const handleClick = () => setShow(!show)

  return (
    <FormControl isRequired={isRequired} isInvalid={Boolean(error)} {...rest}>
      <FormLabel>{label}</FormLabel>
      <InputGroup>
        <Input
          h="48px"
          id={id}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          pr='4.5rem'
          type={show ? 'text' : 'password'}
        />
        <InputRightElement width='4.5rem' h="48px">
          <Button type='button' bg='transparent' size='sm' onClick={handleClick}>
            {show ? 'Hide' : 'Show'}
          </Button>
        </InputRightElement>
      </InputGroup>
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  )
}

export default FormInputPassword
